var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"1200px"}},[(_vm.$store.state.account)?_c('h1',[_vm._v(_vm._s(_vm.greet(_vm.$store.state.account)))]):_vm._e(),_c('RouteView',{attrs:{"route":_vm.route}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }